import React from 'react'
import styled from 'styled-components'
import { BotFeatures } from '@feedyou-ai/feedbot-schema'

import { TreeTab } from './TreeTab'
import { WizardTab } from './WizardTab'
import { AnalyticsTab } from './AnalyticsTab'
import { CallsListTab } from './CallsListTab'
import { useAccessLevel } from '../../../../store/user'
import { ConversationsListTab } from './ConversationsListTab'
import { useBotConfiguration } from '../../../../features/serverBots/hooks/useBotConfiguration'
import { endpointHelpers } from '../../../../features/serverBots/endpointHelpers'
import { getTelephonyChannel } from '../../../../lib/bot/getTelephonyChannel'
import { useFeature } from '../../../../store/features'
import { useSdkFeature } from '../../../../features/hostingVersions'
import { BotTesterTab } from './BotTesterTab'

export const Tabs: React.FC = () => {
  const isConversationsListEnabled = useFeature('CONVERSATIONS_LIST')
  const isBotTesterEnabled = useFeature('BOT_TESTER')
  const isWizardViewEnabled = useSdkFeature(BotFeatures.WIZARD_MODE)
  const hasPowerbiEmbedUrl = !!useBotConfiguration()?.powerbiEmbedUrl

  const { callsList, analytics: canAccessAnalytics } = useAccessLevel()
  const latestSemver = endpointHelpers.getLatestSemverForCurrentBot.useQueryData()
  const originalVersion = endpointHelpers.getOriginalVersionFlowForCurrentBot.useQueryData({
    customVersion: latestSemver
  })

  if (!originalVersion) {
    // Simple way to wait for load :D
    return null
  }

  const isTelephony = !!getTelephonyChannel(originalVersion)
  const canShowAnalyticsTab = hasPowerbiEmbedUrl && canAccessAnalytics
  const canShowCallsListTab = isConversationsListEnabled ? callsList : callsList && isTelephony

  // Show tabs if we have Wizard enabled OR other tabs available
  // Always show TreeTab (Designer), but Wizard is conditional on feature flag
  if (!canShowCallsListTab && !canShowAnalyticsTab && !isBotTesterEnabled && !isWizardViewEnabled) {
    return null
  }

  const callsListTab = isConversationsListEnabled ? <ConversationsListTab /> : <CallsListTab />
  return (
    <StyledTabGroup>
      {isWizardViewEnabled && <WizardTab />}
      <TreeTab />
      {canShowAnalyticsTab && <AnalyticsTab />}
      {canShowCallsListTab && callsListTab}
      {isBotTesterEnabled && <BotTesterTab />}
    </StyledTabGroup>
  )
}

const StyledTabGroup = styled.div`
  border: none;
  display: flex;
  flex-direction: row;
`
